<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-navigation-drawer
    v-bind:value="value"
    v-on:input="onInput"
    fixed
    temporary
    right
    width="520"
    class="right-nav-drawer "
  >
    <v-layout fill-height column>
      <v-toolbar flat dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn @click="close" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-flex class="sidenav-body pa-3">
        <slot name="body"> <div style="height: 1500px"></div> </slot>
      </v-flex>
      <v-flex v-if="actions" class="sidenav-actions">
        <slot name="actions">
          <v-btn
            @click="$emit('cancel')"
            color="primaryLight4"
            outline
            medium
            depressed=""
            >Cancel</v-btn
          >
          <v-btn
            @click="$emit('save')"
            color="accent"
            medium
            depressed=""
            :loading="actionLoading"
            >Save</v-btn
          >
        </slot>
      </v-flex>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'SideNav',
  props: ['value', 'title', 'delete', 'actions', 'actionLoading'],
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="stylus">
.right-nav-drawer{
    .v-toolbar {
        background: linear-gradient(90deg, #24C89A 2.62%, #425486 100%);
    }
    .sidenav-body {
        height 100%
        overflow auto
        display flex
        align-items center
        justify-content center
    }
    .sidenav-actions {
        height: 60px
        background-color $color-primary-light-7
        display flex
        align-items center
        justify-content center
    }

}
</style>
